import { jsx as _jsx } from "react/jsx-runtime";
var DetailNotes = function () {
    return (_jsx("div", { className: "flex h-full" }));
};
export default DetailNotes;
